import React from 'react';

import { Route, Redirect } from 'react-router';
import { isAuthenticated } from './auth';

function PrivateRoute({ component: Component, ...rest }) {
    function verifyUserPermission() {
        const userType = localStorage.getItem("_userType");
        if (userType === 'acesso') {
            const accessInfo = JSON.parse(localStorage.getItem("_accessInfos"));
            let access = false;
            if (rest.admFin) {
                accessInfo.tipos.forEach(obj => {
                    if (obj.tipo === "Administrador" || obj.tipo.includes("Administrativo-Financeiro")){
                        access = true;
                        return;
                    }
                })
            }
            else if (rest.admin || rest.academy) {
                accessInfo.tipos.forEach(obj => {
                    if (obj.tipo === "Administrador"){
                        access = true;
                        return;
                    }
                })
            }
            return access;
        }
        else if(userType === 'aluno'){
            if(rest.student)
                return true;
            return false;
        }
        else if(userType === 'academia'){
            if(rest.academy)
                return true;
            return false;
        }
        else if(userType === 'professor'){
            if(rest.coach)
                return true;
            return false;
        }
        return false;
    }
    function selectUserType() {
        if (rest.academy)
            return "academia";
        if (rest.coach)
            return "professor";
        if (rest.student)
            return "aluno";
        if (rest.admFin)
            return "Administrativo-Financeiro";
        if (rest.admin)
            return "Administrador";
        else
            return "";
    }

    return (
        <Route {...rest} render={props => (
            verifyUserPermission()/* isAuthenticated(selectUserType()) */ ? (
                <Component {...props} />
            ) : (
                <Redirect to={{ pathname: '/', state: { from: props.location } }} />
            )
        )}
        />
    )
}

export default PrivateRoute;